export const ActivityTypeConstants = {
    SPORT_SHOOTING: 'e5da7734-eb78-4844-aba3-56392e48e3ba',
    HUNT_RELATED: '1c1f7fc6-491a-44dc-a38e-64ff712f9784',
    NON_ACTIVE_REPORT: 'bd9278c4-0ad1-44c6-996a-96108f1d7dcb'
}